import { DbCustomerLottery } from "./db-customer-lottery";
import { DbCustomerTasks, DbCustomerFinishedTasks, DbCustomerPrinters } from "./db-customer-tasks";
import { IDocumentReference, ICollectionReference } from '../database-cast/IDatabase';
import { DbObjectBase } from './db-object-base';
import { Customer } from '../../../core/_shared/models/Customer';
import { Method } from '../../../core/_shared/models/method';
import { DbMethodTasks } from './db-method-tasks';
import { DbMethodCoverWhells } from "./DbMethodCoverWhells";


export class DbMethod extends DbObjectBase<Method> {



    constructor(id: string, collection: ICollectionReference) {

      super(id,collection);

  
  }



    public getWaitingTasks(): DbMethodTasks {
        let tasks = new DbMethodTasks(this._docReference.collection("waiting-tasks"));

      return tasks;
  }

  

  public getProcessingTasks(): DbMethodTasks {
    let tasks = new DbMethodTasks(this._docReference.collection("processing-tasks"));

  return tasks;
}

  public getCoverWhells(): DbMethodCoverWhells {
    let tasks = new DbMethodCoverWhells(this._docReference.collection("cover-whells"));

  return tasks;
}



}